import type { ITextBlock, ITextBlockItem } from '~~/types/local_types';

/**
 * Return the text blocks from the RTE content
 * @param blocks
 */
const mapTextBlocks = (blocks: Array<ITextBlock> | undefined) => {
  if (!blocks?.length) {
    return;
  }
  /**
   * Process the nested list items recursively
   * @param textBlockItems
   */
  const processNestedList = (textBlockItems: Array<ITextBlockItem>) => {
    const contents: Array<string> = [];

    const recurse = (items: Array<ITextBlockItem> | undefined) => {
      items?.forEach((i: ITextBlockItem) => {
        if (i.content) {
          contents.push(i.content);
        }
        if (i.items?.length) {
          recurse(i.items);
        }
      });
    };

    recurse(textBlockItems);
    return contents.join(' ');
  };

  return blocks
    ?.map((block: ITextBlock) => {
      if (block.data?.items?.length) {
        return processNestedList(block.data?.items);
      }
      return block.data.text;
    })
    .join(' ');
};

export default mapTextBlocks;
